import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Novedad } from '../models/novedad.model';

@Injectable({
  providedIn: 'root',
})
export class NovedadService {
  URL = 'https://hazmatargentina.com/hazmat/public/api/v1/posts';

  constructor(private http: HttpClient) {}

  getNovedades(): Observable<any> {
    return this.http.get(this.URL);
  }

  getNovedadPerPage(): Observable<any> {
    return this.http.get<Novedad[]>(this.URL + '?per_page=3');
  }

  getNovedad(id): Observable<any> {
    return this.http.get<Novedad[]>(this.URL + '/' + id);
  }

  getNovedadRel(id): Observable<any> {
    return this.http.get<Novedad[]>(this.URL + '/' + id + '/related');
  }

  getNovedadesByCategory(id): Observable<any> {
    return this.http.get<Novedad[]>(this.URL + '?categoria_id=' + id);
  }

  // /hazmat/public/api/v1/posts?categoria_id=1
}

